import { extendTheme } from "@chakra-ui/react";

import colors from "./config/colors";
import space from "./config/space";
import shadows from "./config/shadows";

import components from "./config/components";
import styles from "./config/styles";
import semanticTokens from "./config/semanticTokens";
import fontSizes from "./config/fontSizes";
import fonts from "./config/fonts";
import radii from "./config/radii";
import textStyles from "./config/textStyles";

const theme = extendTheme({
  styles,
  colors,
  semanticTokens,
  components,
  space,
  fonts,
  fontSizes,
  shadows,
  radii,
  textStyles,
});

export default theme;
